<!--
    file type .....: HTML file: dw-dropdown.component.html
    Created By ....: ianday
    Date ..........: 11/8/23 
-->

<mat-select [id]="_id"
            [(ngModel)]="selectedItem"
            [multiple]="multiSelect"
            ngDefaultControl
            [disabled]="disabled"
            floatLabel="never"
            disableOptionCentering
            [style]="{'width': _controlWidth, 'font-size':_fontSize}"
            [style.backgroundColor]="disabled?'light-gray':'white'"
            panelClass="local-drop-down-panel mat-elevation-z2"
            [ngClass]="selectionClass"
            (keydown)="onDropDownKeyDown($event)"
            (selectionChange)="onDwItemSelected($event)"
            placeholder="{{placeholder}}" type="text">
    <mat-option *ngFor="let rec of _dataSource"
                [value]="rec.id">{{rec.description}}
    </mat-option>
</mat-select>
